export default __webpack_public_path__ + "static/media/mernstack.88482d7e.png";